import React from 'react';
import { useEffect, useRef } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import commuteImage from '../../_styles/images/Commute.png';
import Star from '../../_styles/images/Star.png';
import VanGreen from '../../_styles/images/VanGreen.png';
import Insurance from '../../_styles/images/Insurance.png';
import Calendar from '../../_styles/images/Calendar.png';
import { DriverStatus } from './common/driver-status/DriverStatus';
import { getDriverStatus } from '../helper';
import analyticsService from '../../shared/analytics/analytics-service';
import dateUtility from '../../shared/dateUtility';
import ErrorCircle from '../../_styles/images/new-icons/driver-status/error_circle.svg';


function DriverInformation(props) {
    const { driver, isSubscription, isPreferenceChanging, subscriptionAPIInfo, userProfile, profileLoaded, fromProfile, onlyPersonalProfile } = props;
    const isHawaii = !!(driver && driver.state && driver.state.toLowerCase().includes('hawaii'));
    const license = driver && driver.license ? "********" + driver.license.charAt(driver.license.length - 1) : "";
    const statusInfo = getDriverStatus(props.status, driver, userProfile, props.driverMvrStatus);
    //const dStatus = props.status;
    var isNewSubscription = false;
    if (props.subscriptionAPIInfo && props.subscriptionAPIInfo.package === null && props.subscriptionAPIInfo.pendingChange !== null) {
        isNewSubscription = true
    }
    const lastPageName = useRef(null);

    useEffect(() => {
        let pageName = null;
        if (driver && !driver.isDriver && statusInfo && statusInfo.status === 'N/A') {
            pageName = 'drivers license/become a driver';
        } else if (driver && driver.isDriver && statusInfo && statusInfo.status === 'approved') {
            pageName = 'drivers license/view';
        }

        if (pageName && pageName !== lastPageName.current) {
            analyticsService.getPageName({'pagename': pageName});
            lastPageName.current = pageName;
        }
    }, [driver, driver && driver.isDriver, statusInfo && statusInfo.status]);

    function sendAnalytics() {
        analyticsService.analyticsProcessEvent({
            "event": "click_generic",
            "context": {
                "event_action": "Apply to be a driver"
            }
        });
    }

    function passAnalyticsBannerEvent(str) {
        var bannerTopic = '';
        if(statusInfo.status === 'declined' ) {
            bannerTopic = "driver license/declined"
        }
        if(statusInfo.status === 'expiring') {
            bannerTopic = "driver license/expiring soon"
        }
        const banner_topic = 
          analyticsService.analyticsProcessEvent({
            "event": "banner interaction",
            "context": {
              "event_action": "confirm renewal",
              "banner_topic": bannerTopic,
            }
          });
    }

    function getButtonByStatus(status, dayDiff, exception) {
        if (status === 'pending') {
          if((userProfile && userProfile.isRenewLicense) && (userProfile && userProfile.isPendingMvr) && !isHawaii){
           return <div className='button-container'>
                <Link className="update-button disabled" to="">
                    CONFIRM RENEWAL
                </Link> </div>
          } 
         else if(userProfile && userProfile.isRenewLicense && !isHawaii){
           return <div className='button-container'>
                <Link className="update-button disabled" to="">
                    CONFIRM RENEWAL
                </Link> </div>
          }
          else if(isHawaii) {
                return <div className='button-container'></div>

          } else if(exception){
                return <div className='button-container'>
                <button className="update-button newException" to="">
                    Pending Approval
                </button> </div>
          }
          else{ 
             return <div className='button-container'></div>
          }
 
        }

        const inRenewalWindow = status === 'expiring' && dayDiff > 5 && dayDiff <= 30;
        const isUrgentOrExpired = (status === 'expiring' && dayDiff <= 5) || status === 'expired' || (statusInfo.status === 'declined' && statusInfo.isExpiredWithin30days);
        const canRenew = !userProfile.isPendingMvr && !isHawaii;

        if ((inRenewalWindow || (isUrgentOrExpired && userProfile.isRenewLicense)) && canRenew) {
            return <div className='button-container'>
                <Link className="update-button renew" to="/myprofile/license/edit" onClick={() => passAnalyticsBannerEvent("Confirm Renewal")}> 
                   Confirm Renewal
                </Link>
            </div>
        }
        if (status === 'declined' || (status === 'expiring' && (dayDiff && dayDiff > 5)) || ((status === 'expiring' && dayDiff <= 5) && !userProfile.isRenewLicense)) {
            // analyticsService.getPageName({'pagename': 'drivers license/declined'});
            return <div className='button-container'></div>
        }


        return !isHawaii ? 
        <div className='button-container'><Link className="update-button" to="/myprofile/license/edit" onClick={() => props.passAnalyticsClickEvent("update license")}> 
            Update license
        </Link></div>
        :
        <div className='button-container'></div>

    }
    return (
        
        ((driver && !driver.isDriver && (statusInfo && statusInfo.status === 'N/A')) || (statusInfo && statusInfo.status == 'declined' && statusInfo.isExpiredPast30days)) ?
        (
            !isNewSubscription ? 
            <div className='driver-information' role='group'>
                <div className='header'>
                    Driver’s License
                </div>
                <div className='driver-image-container'>
                    <img src={commuteImage} alt="commute Image" />
                </div>
                <div className='main-content'>
                    <div className='driving-info'>
                        <img src={Star} alt="steering" />
                        <div className='content'>Be the star of your commute. Volunteer to split driving duties with your crew.</div>
                    </div>
                    <div className='driving-info'>
                        <img src={VanGreen} alt="steering" />
                        <div className='content'>Authorized drivers can use the vehicle for limited and local utility mileage, up to 200 additional miles per month.</div>
                    </div>
                    <div className='driving-info'>
                        <img src={Calendar} alt="steering" />
                        <div className='content'>Designate different days of the week and drive as often as you want.</div>
                    </div>
                    <div className='driving-info'>
                        <img src={Insurance} alt="steering" />
                        <div className='content'>Auto liability coverage and physical damage protection are included with the vehicle so you can drive with peace of mind.</div>
                    </div>
                </div>
                {
                    isSubscription ?
                        <div className='button-container'>
                            <Link className="update-button" to="/myprofile/applyToDrive" onClick={sendAnalytics}>
                                Apply to be a driver
                            </Link>
                        </div>
                        :
                        <div className='button-container'>
                            <Link className="update-button" to="/driver-application?fromProfile=true" onClick={sendAnalytics}>
                                Apply to be a driver
                            </Link>
                        </div>

                }

            </div> :
            null
        )
            :
            <div className='driver-information' role='group'>
                <div className='header'>
                    Driver’s License
                </div> 
                {statusInfo && statusInfo.hideDriverBanner ?
                    null :
                    (statusInfo && statusInfo.status) ?
                        <DriverStatus statusInfo={statusInfo} isPreferenceChanging={isPreferenceChanging} userProfile={userProfile} driver={driver} profileLoaded={profileLoaded} fromProfile={fromProfile} onlyPersonalProfile={onlyPersonalProfile} /> :
                        <div className='sub-heading'>
                            Thank you for driving in the vanpool!
                        </div>
                }
                <div className='main-content'>
                    <div className='driver-details'>
                        <div className='driver-details-top'>
                            {
                                statusInfo && statusInfo.status && statusInfo.status !== 'N/A' && !statusInfo.newException &&
                               // dStatus && (dStatus.toLowerCase().includes('declined') || dStatus.toLowerCase().includes('approved')) &&
                                <div className='section'>
                                    <div className='label'>Status</div>
                                    <div className='value'>{statusInfo.status == 'declined' ? 'Declined' : statusInfo.status == 'pending' ? 'Pending' :  'Approved'}</div>
                                </div>
                            }
                            <div className='section'>
                                <div className='label'>License</div>
                                <div className='value'>{license}</div>
                            </div>
                        </div>
                        <div className='driver-details-bottom'>
                            <div className='section'>
                                <div className='label'>State</div>
                                <div className='value'>{driver && driver.state}</div>
                            </div>
                            {
                                driver && driver.licenseExpiry &&
                                <div className='section'>
                                     {
                                        (userProfile.isRenewLicense || userProfile.isPendingMvr || statusInfo.status === 'declined' || statusInfo.status === 'expired' || statusInfo.status === 'expiring') && <img className='tick-icon' src={ErrorCircle} alt="image icon" />
                                     } 
                                    <div className='label'>Expiration Date</div>
                                    <div className='value'>
                                        {driver && driver.licenseExpiry && dateUtility.parseFormalDate(driver.licenseExpiry)}</div>

                                </div>
                            }
                        </div>
                    </div>
                </div>
                {statusInfo && getButtonByStatus(statusInfo.status, statusInfo.dayDiff, statusInfo.newException)}
                {(() => {
                    if (!statusInfo || isHawaii) return null;
                    const dayDiff = statusInfo.dayDiff || statusInfo.remainingDays;
                    const isExpiring = statusInfo.status === 'expiring';
                    const inRenewalWindow = isExpiring && dayDiff > 5 && dayDiff <= 30;
                    const isUrgentOrExpired = (isExpiring && dayDiff <= 5) || statusInfo.status === 'expired' || (statusInfo.status === 'declined' && statusInfo.isExpiredWithin30days);
                    const showLegalInfo = inRenewalWindow || (isUrgentOrExpired && userProfile.isRenewLicense);
                    return showLegalInfo && (
                        <div className='legal-info'>
                            By clicking “Confirm Renewal”, you confirm that you have renewed your license and you consent to allow Commute with Enterprise to run your MVR to verify your driving status, per your authorization in the Vanpool Coordinator/Driver Agreement.
                        </div>
                    );
                })()}
            </div>
    );
}

export default connect(null, null)(DriverInformation);
